import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/mmc-reset.css';
import './styles/mmc-ui.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('[PWA] Service Worker registered', reg))
      .catch(err => console.error('[PWA] Service Worker failed', err));
  });
}